import { ExampleSchemaWithRunsAndOptionalFields } from '@/types/schema';

export function isDatasetExample(
  example: ExampleSchemaWithRunsAndOptionalFields
) {
  return example.dataset_id != null;
}
